import script from "./EmailUpdateDoneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailUpdateDoneDialog.vue?vue&type=script&setup=true&lang=js"

import "./EmailUpdateDoneDialog.vue?vue&type=style&index=0&id=76fe2cb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76fe2cb2"]])

export default __exports__